module.exports = __webpack_public_path__ + "static/media/syncui_124.8b5752bf.ico";